// import React, { useState } from 'react';
// import { Menu, X, Wrench } from 'lucide-react';
// import './Navigation.css';

// const Navigation = ({ currentPage, setCurrentPage }) => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const navItems = [
//     { id: 'home', label: 'Home' },
//     { id: 'about', label: 'About' },
//     { id: 'contact', label: 'Contact' }
//   ];

//   return (
//     <nav className="navigation">
//       <div className="nav-container">
//         <div className="nav-content">
//           <div className="nav-brand">
//             <Wrench className="brand-icon" />
//             <span className="brand-text">Megapix Machinery
// </span>
//           </div>

//           {/* Desktop Navigation */}
//           <div className="nav-desktop">
//             <div className="nav-links">
//               {navItems.map((item) => (
//                 <button
//                   key={item.id}
//                   onClick={() => setCurrentPage(item.id)}
//                   className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
//                 >
//                   {item.label}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Mobile menu button */}
//           <div className="nav-mobile-toggle">
//             <button
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="mobile-menu-btn"
//             >
//               {isMenuOpen ? <X className="menu-icon" /> : <Menu className="menu-icon" />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Navigation */}
//         {isMenuOpen && (
//           <div className="nav-mobile">
//             <div className="mobile-links">
//               {navItems.map((item) => (
//                 <button
//                   key={item.id}
//                   onClick={() => {
//                     setCurrentPage(item.id);
//                     setIsMenuOpen(false);
//                   }}
//                   className={`mobile-link ${currentPage === item.id ? 'active' : ''}`}
//                 >
//                   {item.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default Navigation;






// import React, { useState } from 'react';
// import { Menu, X, Wrench, MessageCircle } from 'lucide-react';
// import './Navigation.css';

// const Navigation = ({ currentPage, setCurrentPage }) => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const navItems = [
//     { id: 'home', label: 'Home' },
//     { id: 'about', label: 'About' },
//     { id: 'directors', label: 'Directors' },
//     { id: 'careers', label: 'Careers' },
//     { id: 'contact', label: 'Contact' }
//   ];

//   return (
//     <nav className="navigation">
//       <div className="nav-container">
//         <div className="nav-content">
//           <div className="nav-brand">
//             <Wrench className="brand-icon" />
//             <span className="brand-text">Megapix Machinery</span>
//           </div>

//           {/* Desktop Navigation */}
//           <div className="nav-desktop">
//             <div className="nav-links">
//               {navItems.map((item) => (
//                 <button
//                   key={item.id}
//                   onClick={() => setCurrentPage(item.id)}
//                   className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
//                 >
//                   {item.label}
//                 </button>
//               ))}
//               <button
//                 onClick={() => setCurrentPage('enquiry')}
//                 className="enquiry-btn"
//               >
//                 <MessageCircle className="enquiry-icon" />
//                 Enquiry
//               </button>
//             </div>
//           </div>

//           {/* Mobile menu button */}
//           <div className="nav-mobile-toggle">
//             <button
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="mobile-menu-btn"
//             >
//               {isMenuOpen ? <X className="menu-icon" /> : <Menu className="menu-icon" />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Navigation */}
//         {isMenuOpen && (
//           <div className="nav-mobile">
//             <div className="mobile-links">
//               {navItems.map((item) => (
//                 <button
//                   key={item.id}
//                   onClick={() => {
//                     setCurrentPage(item.id);
//                     setIsMenuOpen(false);
//                   }}
//                   className={`mobile-link ${currentPage === item.id ? 'active' : ''}`}
//                 >
//                   {item.label}
//                 </button>
//               ))}
//               <button
//                 onClick={() => {
//                   setCurrentPage('enquiry');
//                   setIsMenuOpen(false);
//                 }}
//                 className="mobile-enquiry-btn"
//               >
//                 <MessageCircle className="enquiry-icon" />
//                 Enquiry
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default Navigation;








import React, { useState } from 'react';
import { Menu, X, Wrench, MessageCircle } from 'lucide-react';
import './Navigation.css';

const Navigation = ({ currentPage, setCurrentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'directors', label: 'Leadership' },
    { id: 'careers', label: 'Careers' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-content">
          <div className="nav-brand">
            <Wrench className="brand-icon" />
            <span className="brand-text">Megapix Machinery</span>
          </div>

          {/* Desktop Navigation */}
          <div className="nav-desktop">
            <div className="nav-links">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => setCurrentPage(item.id)}
                  className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => setCurrentPage('contact')}
                className="enquiry-btn"
              >
                <MessageCircle size={16} className="enquiry-icon" />
                Enquiry
              </button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="nav-mobile-toggle">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="mobile-menu-btn"
            >
              {isMenuOpen ? <X size={24} className="menu-icon" /> : <Menu size={24} className="menu-icon" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="nav-mobile">
          <div className="mobile-links">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  setCurrentPage(item.id);
                  setIsMenuOpen(false);
                }}
                className={`mobile-link ${currentPage === item.id ? 'active' : ''}`}
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => {
                setCurrentPage('contact');
                setIsMenuOpen(false);
              }}
              className="mobile-enquiry-btn"
            >
              <MessageCircle size={16} />
              Enquiry
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;